import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import forceRankAxios from '../../axios/forceRank'

// index_calculate_list
export const fetchForceRankFilter = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }

    dispatch(fetchForceRankFilterStart())

    forceRankAxios
      .get('/index_calculate_list', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const {
            data: { original }
          } = response.data

          if (original && original.message === '2002') {
            dispatch(
              enqueueSnackbar({
                message: 'SomeStatusNotClose',
                options: {
                  variant: 'error'
                }
              })
            )
            dispatch(fetchForceRankFilterFailed())
          } else {
            dispatch(
              enqueueSnackbar({
                message: 'IndexCalculateSuccess',
                options: {
                  variant: 'success'
                }
              })
            )
            dispatch(fetchForceRankFilterSuccess())
          }

          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })
          dispatch(fetchForceRankFilterSuccess(dataWithOption, pagination, total))
        }
      })
      // .catch(error => {
      //   dispatch(fetchForceRankFilterFailed(error))
      // })
      .catch(error => {
        if (error.response?.status) {
          switch (error.response.status) {
            default:
              dispatch(
                enqueueSnackbar({
                  message: error.response.data.data.Error,
                  options: {
                    variant: 'error'
                  }
                })
              )
              break
          }
        }
        dispatch(fetchForceRankFilterFailed())
      })
  }
}

export const fetchForceRankFilterStart = () => {
  return {
    type: actionTypes.FETCH_FORCERANK_FILTER_START
  }
}

export const fetchForceRankFilterSuccess = (data, pagination, total) => {
  return {
    type: actionTypes.FETCH_FORCERANK_FILTER_SUCCESS,
    data,
    pagination,
    total
  }
}

export const fetchForceRankFilterFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FORCERANK_FILTER_FAILED,
    errorMessage
  }
}

export const createForceRank = (recordData, page) => {
  return dispatch => {
    dispatch(createForceRankStart())

    forceRankAxios
      .post('/storeForceRank', recordData)
      .then(response => {
        if (response.status === 200) {
          dispatch(
            enqueueSnackbar({
              message: 'AdjustGradeCreated',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createForceRankSuccess())
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'InvalidAdjustGradeField',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createForceRankFailed())
      })
  }
}

export const createForceRankStart = () => {
  return {
    type: actionTypes.CREATE_FORCERANK_START
  }
}
export const createForceRankSuccess = () => {
  return {
    type: actionTypes.CREATE_FORCERANK_SUCCESS
  }
}
export const createForceRankFailed = () => {
  return {
    type: actionTypes.CREATE_FORCERANK_FAILED
  }
}

export const fetchForceRankFilterCompany = filter => {
  return dispatch => {
    dispatch(fetchForceRankFilterCompanyStart())
    forceRankAxios
      .get('/company/dropdown', { params: filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchForceRankFilterCompanySuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchForceRankFilterCompanyFailed(error))
      })
  }
}

export const fetchForceRankFilterCompanyStart = () => {
  return {
    type: actionTypes.FETCH_FORCERANK_FILTER_COMPANY_START
  }
}

export const fetchForceRankFilterCompanySuccess = data => {
  return {
    type: actionTypes.FETCH_FORCERANK_FILTER_COMPANY_SUCCESS,
    data
  }
}

export const fetchForceRankFilterCompanyFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FORCERANK_FILTER_COMPANY_FAILED,
    errorMessage
  }
}

// Force Rank List

export const fetchForceRankList = data => {
  return dispatch => {
    dispatch(fetchForceRankListStart())
    forceRankAxios
      .post('/force_rank', data)
      .then(response => {
        // if (response.status === 200) {
        //   dispatch(fetchForceRankListSuccess(response.data.data))
        // }
        if (response.status === 200) {
          dispatch(
            enqueueSnackbar({
              message: 'ForceRankSuccess',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(fetchForceRankListSuccess(response.data.data))
        }
      })
      // .catch(error => {
      //   dispatch(fetchForceRankListFailed(error))
      // })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'ForceRankFailed',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(fetchForceRankListFailed())
      })
  }
}

export const fetchForceRankListStart = () => {
  return {
    type: actionTypes.FETCH_FORCERANK_LIST_START
  }
}

export const fetchForceRankListSuccess = data => {
  return {
    type: actionTypes.FETCH_FORCERANK_LIST_SUCCESS,
    data
  }
}

export const fetchForceRankListFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FORCERANK_LIST_FAILED,
    errorMessage
  }
}

// Force Rank List (2)

export const fetchReStoreForceRankList = data => {
  return dispatch => {
    dispatch(fetchReStoreForceRankListStart())
    forceRankAxios
      .post('/force_rank', data)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchReStoreForceRankListSuccess(response.data.data))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'ForceRankFailed',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(fetchReStoreForceRankListFailed())
      })
  }
}

export const fetchReStoreForceRankListStart = () => {
  return {
    type: actionTypes.FETCH_FORCERANK_LIST_START
  }
}

export const fetchReStoreForceRankListSuccess = data => {
  return {
    type: actionTypes.FETCH_FORCERANK_LIST_SUCCESS,
    data
  }
}

export const fetchReStoreForceRankListFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FORCERANK_LIST_FAILED,
    errorMessage
  }
}

export const fetchForceRankCalculate = data => {
  return dispatch => {
    dispatch(fetchForceRankCalculateStart())
    forceRankAxios
      .post('/calculate_index', data)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchForceRankCalculateSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchForceRankCalculateFailed(error))
      })
  }
}

export const fetchForceRankCalculateStart = () => {
  return {
    type: actionTypes.FETCH_FORCERANK_CALCULATE_START
  }
}

export const fetchForceRankCalculateSuccess = data => {
  return {
    type: actionTypes.FETCH_FORCERANK_CALCULATE_SUCCESS,
    data
  }
}

export const fetchForceRankCalculateFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FORCERANK_CALCULATE_FAILED,
    errorMessage
  }
}

// Adjust

export const fetchAdjust = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }

    dispatch(fetchAdjustStart())

    forceRankAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200) {
          const {
            current_page,
            from,
            last_page,
            per_page,
            to,
            total,
            data
          } = response.data.data.result_header
          const adjustData = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }
          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })
          dispatch(fetchAdjustSuccess(dataWithOption, pagination, total, adjustData))
        }
      })
      .catch(error => {
        dispatch(fetchAdjustFailed(error))
      })
  }
}

export const fetchAdjustStart = () => {
  return {
    type: actionTypes.FETCH_ADJUST_START
  }
}

export const fetchAdjustSuccess = (data, pagination, total, adjustData) => {
  return {
    type: actionTypes.FETCH_ADJUST_SUCCESS,
    data,
    pagination,
    total,
    adjustData
  }
}

export const fetchAdjustFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ADJUST_FAILED,
    errorMessage
  }
}
